/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_AriaInputs */

const en_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export combined continuity and spotting list`)
};

const fr_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la liste combinee de continuite et de reperage`)
};

const de_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export kombinierte Kontinuitäts- und Spotting-Liste`)
};

const it_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione di un elenco combinato di continuità e spotting`)
};

const ru_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединенный список непрерывности экспорта и спотовых публикаций`)
};

const es_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar lista combinada de continuidad y detección`)
};

const zh_cn2_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出综合连续性和定位列表`)
};

const ja_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連続性とスポッティングリストを組み合わせたエクスポート`)
};

const hi_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात की जाने वाली संयुक्त निरंतरता और स्पॉटिंग सूची`)
};

const pt_pt2_file_export_ccsl_aria = /** @type {(inputs: File_Export_Ccsl_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista combinada de continuidade e localização para exportação`)
};

/**
* | output |
* | --- |
* | "Export combined continuity and spotting list" |
*
* @param {File_Export_Ccsl_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_aria = /** @type {((inputs?: File_Export_Ccsl_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_ccsl_aria(inputs)
	if (locale === "de") return de_file_export_ccsl_aria(inputs)
	if (locale === "it") return it_file_export_ccsl_aria(inputs)
	if (locale === "ru") return ru_file_export_ccsl_aria(inputs)
	if (locale === "es") return es_file_export_ccsl_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_ccsl_aria(inputs)
	if (locale === "ja") return ja_file_export_ccsl_aria(inputs)
	if (locale === "hi") return hi_file_export_ccsl_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_ccsl_aria(inputs)
	return en_file_export_ccsl_aria(inputs)
});